<ng-template #defaultIndicatorTemplate>
  <span class="ant-spin-dot" [class.ant-spin-dot-spin]="loading">
    <i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i>
  </span>
</ng-template>
<div *ngIf="loading">
  <div class="ant-spin"
    [class.ant-spin-spinning]="loading"
    [class.ant-spin-lg]="nzSize === 'large'"
    [class.ant-spin-sm]="nzSize === 'small'"
    [class.ant-spin-show-text]="nzTip">
    <ng-template [ngTemplateOutlet]="nzIndicator || defaultIndicatorTemplate"></ng-template>
    <div class="ant-spin-text" *ngIf="nzTip">{{ nzTip }}</div>
  </div>
</div>
<div *ngIf="!nzSimple"
  class="ant-spin-container"
  [class.ant-spin-blur]="loading">
  <ng-content></ng-content>
</div>
